import { useTranslation } from "react-i18next";
import { getCurrentLanguage } from "@/helpers/get-current-langage";
import { kuwaitForecastType } from "@/schemas/kuwait-forecast-schema";

import DivSkeleton from "@/components/skeletons/DivSkeleton";

import "./style.scss";

type PrevisionDescriptionContentProps = {
	forecastData: kuwaitForecastType | null;
	isLoading: boolean;
	error: string | null;
	date: Date;
};

export const PrevisionDescriptionContent = ({
	forecastData,
	isLoading,
	error,
	date,
}: PrevisionDescriptionContentProps) => {
	const { t } = useTranslation();
	const lang = getCurrentLanguage();
	const langFormat = lang === "ar" ? "AR" : "EN";

	return (
		<div className="prevision-description-content">
			{isLoading ? (
				<DivSkeleton />
			) : error ? (
				<div className="empty-forecast">
					<p>No data for {date.toDateString()}</p>
				</div>
			) : (
				<div className="content-wrapper">
					{forecastData ? (
						<div className="content-weather">
							<p className="title"> {t("weatherState")} </p>

							<div className="weather-content">
								<p className="title"> {t("byDay")}</p>
								<p className="desc">
									{forecastData?.[`weather_state_AM_${langFormat}`]}
								</p>
							</div>

							<div className="weather-content">
								<p className="title">{t("byNight")}</p>
								<p className="desc">
									{forecastData?.[`weather_state_PM_${langFormat}`]}
								</p>
							</div>
						</div>
					) : (
						<div className="empty-forecast">
							<p>No data for {date.toDateString()}</p>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default PrevisionDescriptionContent;
